import { render, staticRenderFns } from "./upAppendix.vue?vue&type=template&id=19db69e0&scoped=true&"
import script from "./upAppendix.vue?vue&type=script&lang=js&"
export * from "./upAppendix.vue?vue&type=script&lang=js&"
import style0 from "./upAppendix.vue?vue&type=style&index=0&id=19db69e0&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db69e0",
  null
  
)

export default component.exports